module.exports = __webpack_public_path__ + "img/carbonara_eggs.d53a13d8.jpg";